/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/flag/custom-elements';

import { defineCustomElement as defineOsdsFlag } from '@ovhcloud/ods-stencil/components/flag/custom-elements/osds-flag.js';

export const OsdsFlag = /*@__PURE__*/createReactComponent<JSX.OsdsFlag, HTMLOsdsFlagElement>('osds-flag', undefined, undefined, defineOsdsFlag);
